import { extendTheme } from '@chakra-ui/react';

const customTheme = extendTheme({
  colors: {
    brand: {
      100: '#ccf2d2', // Lightest mint green
      200: '#4ced7d', // Vibrant mint green
      300: '#14542f', // Deep forest green
      400: '#097240', // Secondary shade of deep green
      500: '#000000', // Black for contrast
      600: '#000000', // Black for contrast
      700: '#408754', // Black for contrast
      800: '#2e6d3f', // Black for contrast
      900: '#1f542e', // Black for contrast
    },
  },
  styles: {
    global: {
      'html, body': {
        bg: 'brand.200',
        color: 'brand.500',
        fontFamily: 'PP Neue Montreal, sans-serif',
      },
      ':root': {
        '--chakra-colors-gray-100': 'brand.200',
        '--chakra-colors-gray-200': '#bfdeff',
        '--chakra-colors-gray-300': '#99caff',
      },
    },
  },
  fonts: {
    heading: 'PP Neue Montreal, sans-serif',
    body: 'PP Neue Montreal, sans-serif',
  },
  textStyles: {
    mainTitle: {
      fontFamily: 'heading',
      fontWeight: 'bold',
      fontSize: ['4xl', '6xl', '8xl'], // Responsive sizes
      lineHeight: 'shorter',
    },
    subTitle: {
      fontFamily: 'heading',
      fontWeight: 'medium',
      fontSize: ['3xl', '4xl'],
      lineHeight: 'short',
    },
    subTitle2: {
      fontFamily: 'heading',
      fontWeight: 'book',
      fontSize: ['3xl', '4xl'],
      lineHeight: 'short',
    },
    bodyText: {
      fontFamily: 'body',
      fontWeight: 'regular',
      fontSize: 'lg',
      lineHeight: 'tall',
    },
    accentText: {
      fontFamily: 'heading',
      fontWeight: 'bold',
      fontSize: 'sm',
      lineHeight: 'shorter',
    },
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: 'xl',
        fontWeight: 'bold',
        fontFamily: 'heading',
      },
      variants: {
        solid: {
          bg: 'brand.200',
          color: 'white',
          _hover: {
            bg: 'brand.300',
          },
        },
        outline: {
          borderColor: 'brand.200',
          color: 'brand.200',
          _hover: {
            bg: 'brand.100',
          },
        },
      },
    },
    Checkbox: {
      control: {
        padding: 3, // change the padding of the control
        borderRadius: 0, // change the border radius of the control
        color: 'brand.300',
        borderColor: 'brand.300',
      },
    }
  },
});

export default customTheme;

// Uncomment or adjust the following code if `createSystem`, `defaultConfig`, and `defineConfig` are needed elsewhere:
// import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';
// const customConfig = defineConfig({
//   cssVarsRoot: ':where(html)',
// });
// export const system = createSystem(defaultConfig, customConfig);
